var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointer",on:{"click":_vm.click}},[_c('font-awesome-icon',{class:_vm.classObject,attrs:{"icon":"expand-arrows-alt"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }